export default __webpack_public_path__ + "static/media/SpringFestival_06.50249d58.png";